module.exports = __webpack_public_path__ + "img/Neo.3705b78d.jpg";